import { rankOf, suitOf } from './cards';
/** Classify a 3–5 card board. Throws for other lengths (texture is a postflop concept). */
export const classifyTexture = (board) => {
    const len = board.length;
    if (len < 3 || len > 5) {
        throw new RangeError(`classifyTexture expects a 3–5 card board, got ${len}`);
    }
    // Suit distribution.
    const suitCounts = [0, 0, 0, 0];
    for (const c of board)
        suitCounts[suitOf(c)] += 1;
    const maxSuitCount = Math.max(...suitCounts);
    const monotone = maxSuitCount === len;
    const rainbow = maxSuitCount === 1;
    const twoTone = !monotone && maxSuitCount >= 2;
    // Rank multiplicities.
    const rankCounts = new Array(13).fill(0);
    for (const c of board)
        rankCounts[rankOf(c)] += 1;
    const trips = rankCounts.some((n) => n >= 3);
    const paired = rankCounts.some((n) => n >= 2);
    // Straight connectivity: how many DISTINCT board ranks fall inside the densest 5-rank window.
    // Ace is counted both high (12) and low (-1) so wheels (A-2-3-4-5) register.
    const present = new Set();
    for (let r = 0; r < 13; r++)
        if (rankCounts[r] > 0)
            present.add(r);
    if (present.has(12))
        present.add(-1);
    let maxInWindow = 0;
    for (let lo = -1; lo <= 8; lo++) {
        let count = 0;
        for (let v = lo; v < lo + 5; v++)
            if (present.has(v))
                count += 1;
        if (count > maxInWindow)
            maxInWindow = count;
    }
    const connectedness = maxInWindow >= 3 ? 'connected' : maxInWindow === 2 ? 'semi' : 'disconnected';
    const flushDrawPresent = maxSuitCount >= 2;
    const straightDrawPresent = connectedness !== 'disconnected';
    let textureClass;
    if (monotone)
        textureClass = 'monotone';
    else if (paired)
        textureClass = 'paired';
    else if (twoTone && connectedness === 'connected')
        textureClass = 'wet';
    else if (twoTone && connectedness === 'semi')
        textureClass = 'semi_wet';
    else if (twoTone)
        textureClass = 'two_tone'; // two-tone + disconnected
    else if (connectedness === 'connected')
        textureClass = 'connected'; // rainbow + connected
    else if (connectedness === 'semi')
        textureClass = 'semi_wet'; // rainbow + one-gappers
    else
        textureClass = 'dry'; // rainbow + disconnected
    return {
        textureClass,
        paired,
        trips,
        monotone,
        twoTone,
        rainbow,
        connectedness,
        flushDrawPresent,
        straightDrawPresent,
        maxSuitCount,
    };
};
//# sourceMappingURL=texture.js.map